import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { WaveDivider } from './WaveDivider';
export function MechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="bg-gradient-to-b from-[#3d7a8a] to-[#6aacb8] relative" data-id="element-75">
      <div ref={ref} className="py-16 md:py-24 px-4" data-id="element-76">
        <div className="max-w-3xl mx-auto text-center" data-id="element-77">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-8" data-id="element-78">
            <SparklesIcon className="w-5 h-5 text-amber-300" data-id="element-79" />
            <span className="text-white font-medium" data-id="element-80">La Solución</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-8" data-id="element-81">
            El Método de Discreción Total
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-white/90 leading-relaxed mb-6" data-id="element-82">
            He desarrollado el{' '}
            <span className="font-bold text-amber-300" data-id="element-83">
              Método de Discreción Total
            </span>
            . Es una serie de micro-ajustes físicos invisibles —presiones
            táctiles, respiraciones silenciosas y anclajes mentales— que puedes
            ejecutar mientras hablas con tu supervisor o atiendes una mesa.
            Nadie verá nada, pero tú sentirás cómo el pánico se disuelve en
            segundos.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="text-xl md:text-2xl font-semibold text-white" data-id="element-84">
            Estás hackeando tu sistema nervioso desde adentro, en tiempo real.
          </motion.p>
        </div>
      </div>

      <WaveDivider fillColor="#f8fafc" data-id="element-85" />
    </section>;
}